(() => {
  const deck = document.querySelector('#isyou-deck');
  if (!deck || deck.dataset.ready) return;
  const cards = [...deck.querySelectorAll('.isyou-card')];
  const caption = document.querySelector('#isyou-caption');
  const dots = [...document.querySelectorAll('#isyou-dots span')];
  let current = 0;
  const show = index => {
    current = (index + cards.length) % cards.length;
    cards.forEach((card, i) => {
      card.toggleAttribute('data-active', i === current);
      card.setAttribute('aria-hidden', String(i !== current));
    });
    caption.textContent = cards[current].querySelector('img').alt;
    dots.forEach((dot, i) => dot.classList.toggle('on', i === current));
    deck.dataset.index = String(current);
  };
  deck.dataset.ready = 'true';
  deck.tabIndex = 0;
  show(0);
  let start;
  let suppressClick = false;
  deck.addEventListener('pointerdown', event => { start = {x:event.clientX,y:event.clientY}; suppressClick = false; });
  deck.addEventListener('pointerup', event => {
    if (!start) return;
    const dx = event.clientX-start.x, dy = event.clientY-start.y;
    start = null;
    if (Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)) { show(current+(dx<0?1:-1)); suppressClick = true; }
  });
  deck.addEventListener('pointercancel', () => { start=null; });
  deck.addEventListener('click', () => { if (suppressClick) { suppressClick=false; return; } show(current+1); });
  deck.addEventListener('keydown', event => {
    if (['ArrowLeft','ArrowRight','Enter',' '].includes(event.key)) { event.preventDefault(); show(current+(event.key==='ArrowLeft'?-1:1)); }
  });
  document.querySelectorAll('.isyou-nav').forEach(button => button.addEventListener('click', () => show(current+Number(button.dataset.dir))));
  const tabs = [...document.querySelectorAll('.weekend-tab')];
  const select = index => tabs.forEach((tab,i) => {
    tab.setAttribute('aria-selected',String(i===index));
    tab.tabIndex=i===index?0:-1;
    document.getElementById(tab.getAttribute('aria-controls')).hidden=i!==index;
  });
  tabs.forEach((tab,i) => {
    tab.addEventListener('click',()=>select(i));
    tab.addEventListener('keydown',event=>{
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(i+(event.key==='ArrowLeft'?-1:1)+tabs.length)%tabs.length;
      select(next); tabs[next].focus();
    });
  });
  document.querySelectorAll('.weekend-arrow').forEach(button => button.addEventListener('click',()=>{
    const current=tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true');
    select((current+Number(button.dataset.dir)+tabs.length)%tabs.length);
  }));
  if (tabs.length) select(0);
})();
